
const tooltipRegex = /\[([^\]]+)\]/

export default {
  components: {
    ToolTip: () => import(/* webpackChunkName: "ToolTip" */ '../../ToolTip')
  },
  props: ['value', 'field', 'selection', 'options', 'fullLabel'],
  methods: {
    showTooltip (val) {
      if (val.match(tooltipRegex)) {
        return val.match(tooltipRegex)[1]
      } else {
        return val
      }
    },
    showText (val) {
      if (val.match(tooltipRegex)) {
        return val.replace(tooltipRegex, '')
      } else {
        return val
      }
    }
  }
}
